// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  background: #f9f9f9 !important;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
  font-family: "Fira Sans", sans-serif;
}

body,
html,
.App,
#root,
.auth-wrapper {
  width: 100%;
  height: 100%;
}

.auth-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
}

.auth-inner {
  width: 450px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 10px 55px 45px 55px;
  border-radius: 15px;
  transition: all 0.3s;
}

.auth-wrapper .form-control:focus {
  border-color: #167bff;
  box-shadow: none;
}

.custom-control-label {
  font-weight: 400;
  margin-left: 5px;
}

.custom-control.custom-checkbox.d-flex.align-items-center {
  justify-content: center;
}

img {
  display: block;
  width: 75%;
  margin-left: auto;
  margin-right: auto;
}

@media all and (max-width: 600px) {
  .auth-wrapper {
    display: flex;
    justify-content: center;
    align-items: center; /* Adicionado para centralizar verticalmente */
    text-align: center; /* Alterado para centralizar o texto */
    padding: 20px;
  }

  .auth-inner {
    width: 100%;
    max-width: 450px; /* Adicionado limite máximo de largura */
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
    padding: 10px 20px 30px 20px; /* Ajustado o espaçamento interno */
    border-radius: 15px;
    transition: all 0.3s;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Login/login.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAE,8CAA8C;IACnE,kBAAkB,EAAE,sCAAsC;IAC1D,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB,EAAE,wCAAwC;IAC1D,YAAY;IACZ,mBAAmB;IACnB,+CAA+C;IAC/C,4BAA4B,EAAE,mCAAmC;IACjE,mBAAmB;IACnB,oBAAoB;EACtB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  background: #f9f9f9 !important;\n  min-height: 100vh;\n  display: flex;\n  font-weight: 400;\n  font-family: \"Fira Sans\", sans-serif;\n}\n\nbody,\nhtml,\n.App,\n#root,\n.auth-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.auth-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: left;\n}\n\n.auth-inner {\n  width: 450px;\n  margin: auto;\n  background: #ffffff;\n  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n  padding: 10px 55px 45px 55px;\n  border-radius: 15px;\n  transition: all 0.3s;\n}\n\n.auth-wrapper .form-control:focus {\n  border-color: #167bff;\n  box-shadow: none;\n}\n\n.custom-control-label {\n  font-weight: 400;\n  margin-left: 5px;\n}\n\n.custom-control.custom-checkbox.d-flex.align-items-center {\n  justify-content: center;\n}\n\nimg {\n  display: block;\n  width: 75%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media all and (max-width: 600px) {\n  .auth-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center; /* Adicionado para centralizar verticalmente */\n    text-align: center; /* Alterado para centralizar o texto */\n    padding: 20px;\n  }\n\n  .auth-inner {\n    width: 100%;\n    max-width: 450px; /* Adicionado limite máximo de largura */\n    margin: auto;\n    background: #ffffff;\n    box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n    padding: 10px 20px 30px 20px; /* Ajustado o espaçamento interno */\n    border-radius: 15px;\n    transition: all 0.3s;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
